import { createI18n } from 'vue-i18n';

const fallbackLocale = 'en-US';

function loadLocaleMessages() {
  const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

export const languages = Object.getOwnPropertyNames(loadLocaleMessages());

function checkDefaultLanguage() {
  let matched = null;
  languages.forEach((lang) => {
    if (lang === navigator.language) {
      matched = lang;
    }
  });
  if (!matched) {
    languages.forEach((lang) => {
      const languagePartials = navigator.language.split('-')[0];
      if (lang === languagePartials) {
        matched = lang;
      }
    });
  }
  if (!matched) {
    languages.forEach((lang) => {
      const languagePartials = navigator.language.split('-')[0];
      if (lang.split('-')[0] === languagePartials) {
        matched = lang;
      }
    });
  }
  return matched;
}

export const selectedLocale = checkDefaultLanguage() || fallbackLocale;

export default createI18n({
  // allowComposition: true,
  locale: selectedLocale,
  fallbackLocale,
  messages: loadLocaleMessages(),
  // silentTranslationWarn: true,
  silentFallbackWarn: true,
});
